var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoGovCeWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 606,
    height: 156,
    viewBox: "0 0 606 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2676",
    "data-name": "Caminho 2676",
    d: "M48.329.3a.384.384,0,0,0-.357.357h0V2.976c-1.784,0-3.568.089-5.352.178V.835a.328.328,0,0,0-.089-.268.328.328,0,0,0-.268-.089C40.3.568,38.25.746,36.2.924c-.178,0-.268.178-.268.357V3.6c-1.784.178-3.39.357-5.173.624V1.995a.315.315,0,0,0-.357-.357c-1.338.178-2.676.535-4.014.8a21.24,21.24,0,0,1-2.319.446c-.178,0-.268.178-.268.357V5.83L24.781,7.7c.089.089.178.178.268.178h.178A172.328,172.328,0,0,1,50.559,5.741,166.952,166.952,0,0,1,77.5,8.328h.089c.089,0,.178,0,.178-.089a.328.328,0,0,0,.089-.268V7.7l.8-1.516.178-.357V3.244c0-.178-.089-.268-.268-.357l-.892-.178c-1.695-.357-3.479-.714-5.173-.981a.328.328,0,0,0-.268.089c-.089,0-.089.089-.178.178V4.136c-1.427-.178-2.765-.357-4.1-.446L66.883,3.6V1.37c0-.178-.089-.268-.268-.357C64.653.835,62.6.657,60.55.568a.315.315,0,0,0-.357.357v2.23c-1.784-.089-3.568-.089-5.352-.178V.657A.384.384,0,0,0,54.484.3H48.329",
    transform: "translate(-23.8 -0.3)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -4.892,
    y1: -11.739,
    x2: -4.845,
    y2: -11.739,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8b56d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#edd9b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ecd8af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8b56b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2677",
    "data-name": "Caminho 2677",
    d: "M25,8.919l2.408,2.319A165.218,165.218,0,0,1,51.313,9.187a189.6,189.6,0,0,1,24.619,2.052l1.606-1.516.446-.8A135.725,135.725,0,0,0,52.473,6.6,188.188,188.188,0,0,0,25,8.919",
    transform: "translate(-25 -6.6)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -5.132,
    y1: -21.068,
    x2: -5.083,
    y2: -21.068,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b79644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#c7a865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b89642"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2678",
    "data-name": "Caminho 2678",
    d: "M29.23,11.506,23.7,24.618s13.736-1.606,28.543-1.962a145.978,145.978,0,0,1,27.205,2.052c-.089-.089-5.8-13.29-5.8-13.29s-9.812-1.249-21.5-1.516h-2.5A158.776,158.776,0,0,0,29.23,11.506",
    transform: "translate(-23.7 -9.9)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -4.859,
    y1: -6.807,
    x2: -4.813,
    y2: -6.807,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbb872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e0c28b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbb872"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2681",
    "data-name": "Caminho 2681",
    d: "M17.253,31.476,7.084,44.142c3.836,3.211,6.69,7.225,7.314,12.488.714,6.244-2.052,12.488-4.371,18.107S5.3,86.154,5.3,92.309a11.215,11.215,0,0,0,.446,2.944c2.319,7.493,14,13.647,20.516,17.126,5.173,2.765,10.525,5.352,15.52,8.385a42.579,42.579,0,0,1,7.671,5.441,40.6,40.6,0,0,1,7.4-5.441c5-3.033,10.347-5.619,15.52-8.385,6.957-3.657,21.051-10.882,21.051-20.07,0-6.155-2.319-11.863-4.638-17.483s-5.084-11.953-4.46-18.2c.624-5.263,3.479-9.1,7.314-12.309L81.475,31.476A180.827,180.827,0,0,0,50.434,28.8a207.236,207.236,0,0,0-33.182,2.676",
    transform: "translate(-5.3 -28.8)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.505,
    cy: 0.514,
    r: 0.514,
    gradientTransform: "translate(0.31 -0.016) scale(1.107 0.986)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01a668"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#029d5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#038647"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2696",
    "data-name": "Caminho 2696",
    d: "M24.9,74.53H78.149c.357-16.948-8.563-34.43-26.67-34.43S24.452,57.583,24.9,74.53",
    transform: "translate(-24.882 -40.1)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.323,
    cy: 0.877,
    r: 1.051,
    gradientTransform: "translate(-1.842 -0.047) scale(0.637 0.986)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0f0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#d7ede1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#bee5e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#96d7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#5ec5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5cc4ed"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2733",
    "data-name": "Caminho 2733",
    d: "M24.8,77.478c0,1.249.089,2.5.178,3.746,6.155.178,14.093-.178,14.272.981,0,.178.357.089.624,0s.535-.178.357,0c-2.854,3.122.714,8.563,4.192,11.328C55.484,102.1,51.47,107,42.461,108.876a23.482,23.482,0,0,0,8.92,1.516c10.258,0,17.483-5.53,21.853-13.29-6.6-2.676-17.84-4.014-20.515-9.9-.892-1.962,4.46-5.619,5.263-7.225,1.606-3.033-8.831-2.408-8.474-2.587L24.978,77.3c.178,0,.089.089-.178.178",
    transform: "translate(-24.8 -77.3)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -5.618,
    y1: -4.696,
    x2: -5.565,
    y2: -4.696,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fffbf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#feefdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fcdbb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbd3a4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2734",
    "data-name": "Caminho 2734",
    d: "M24.763,77.257v-.178c-1.338,7.314,1.784,18.642,8.385,25.689,5.441,5.8,13.112,8.3,16.234,7.849h.624c.357,0,.624.089.714-.178,6.868-12.844-18.018-27.295-.357-33,1.249-.357-.981-.535-4.638-.535-6.065,0-16.145.357-20.961.357",
    transform: "translate(-24.459 -76.9)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -8.017,
    y1: -4.239,
    x2: -7.941,
    y2: -4.239,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#09b0b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#22b5ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#4abec2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ec2c6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2735",
    "data-name": "Caminho 2735",
    d: "M78.037,60.089c-6.244.089-5.709,7.4-10.079,7.849-1.07.089-3.568-.714-5.352-1.07C60.2,66.511,55.47,72.22,54.4,75.253H81.249A42.715,42.715,0,0,0,78.483,60a.668.668,0,0,1-.446.089Z",
    transform: "translate(-54.4 -60)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -7.946,
    y1: -9.54,
    x2: -7.85,
    y2: -9.54,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#19a576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#149d6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#068654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#027f4d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2737",
    "data-name": "Caminho 2737",
    d: "M56.033,92.118c4.371,4.549,12.4,5.173,18.286,8.206,4.46-6.065,6.69-14.272,6.779-22.389v-.268L54.338,77.4c-2.5,3.746-3.836,8.92,1.695,14.718",
    transform: "translate(-52.173 -77.4)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -9.792,
    y1: -6.15,
    x2: -9.707,
    y2: -6.15,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9b68b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e4af82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d69c69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf935d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2738",
    "data-name": "Caminho 2738",
    d: "M76.906,69.2c-2.23.268-3.835,3.925-8.206,6.69H82.882a41.24,41.24,0,0,0-.446-5.8c-1.338-.178-3.479-.714-5-.892Z",
    transform: "translate(-68.7 -69.2)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -9.107,
    y1: -19.244,
    x2: -8.924,
    y2: -19.244,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2743",
    "data-name": "Caminho 2743",
    d: "M37.2,63.5V75.363h7.939L45.049,63.5Z",
    transform: "translate(-37.2 -63.5)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -41.528,
    y1: -0.825,
    x2: -41.197,
    y2: -0.825,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbdad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#f7f9fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fafdff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2744",
    "data-name": "Caminho 2744",
    d: "M41.384,53.6c-.446,0-.714.624-1.07,1.07-.268.268-.446.535-.714.8v4.817l.178.268-.089,1.695h3.39l-.089-1.784.714-.178-.089-1.695-.089-2.765a15.507,15.507,0,0,1-1.16-1.338c-.446-.446-.268-.981-.981-.892Z",
    transform: "translate(-39.6 -53.589)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -93.77,
    y1: 17.328,
    x2: -93.125,
    y2: 17.328,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Logo_CE_alto_contraste_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 606,
    height: 156
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_CE_alto_contraste_",
    "data-name": "Logo CE (alto contraste)",
    clipPath: "url(#clip-Logo_CE_alto_contraste_)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logotipo-ceara-branco-2021",
    transform: "translate(12 11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2651",
    "data-name": "Caminho 2651",
    d: "M164.181,24.8c-17.037,0-29.881,11.953-29.881,27.83S147.323,80.549,164,80.549A29.267,29.267,0,0,0,186.927,70.2V68.953l-9.9-8.385h-1.16a15.814,15.814,0,0,1-11.685,5.173,13.169,13.169,0,1,1-1.16-26.313h1.16A16.5,16.5,0,0,1,175.866,44.6h1.16l9.9-8.474v-1.16A30.156,30.156,0,0,0,164.181,24.8",
    transform: "translate(-12.651 -2.155)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2652",
    "data-name": "Caminho 2652",
    d: "M202.6,79.478h41.209V66.009h-24.8V58.428h18.642V45.851H219.012V38.269h24.8V24.8H202.6Z",
    transform: "translate(-19.145 -2.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2653",
    "data-name": "Caminho 2653",
    d: "M420.271,18.842l21.586-8.117V9.566L436.148.2h-1.16L415.9,11.885v1.16l3.211,5.8Z",
    transform: "translate(-39.458 -0.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2654",
    "data-name": "Caminho 2654",
    d: "M447.754,60.568l-6.512-14.539L431.7,24.8H416.624L393.7,79.478h17.215l3.033-8.206h20.426a24.326,24.326,0,0,0,5.263,6.779,13.021,13.021,0,0,0,8.474,2.5,15.868,15.868,0,0,0,7.849-1.784l-7.314-16.323c-.268-.535-.535-1.16-.892-1.873m-29.525-.178,6.065-16.234L430,60.39Z",
    transform: "translate(-36.985 -2.155)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2655",
    "data-name": "Caminho 2655",
    d: "M309.665,60.568l-6.511-14.539L293.7,24.8H278.624L255.7,79.478h17.215l3.033-8.206h20.426a24.327,24.327,0,0,0,5.263,6.779,13.021,13.021,0,0,0,8.474,2.5,15.868,15.868,0,0,0,7.849-1.784l-7.4-16.323a9.145,9.145,0,0,1-.892-1.873m-29.614-.178,6.066-16.323L291.825,60.3Z",
    transform: "translate(-24.021 -2.155)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2656",
    "data-name": "Caminho 2656",
    d: "M369.974,58.071c5.976-2.676,9.9-7.849,9.9-14.985,0-11.15-7.582-18.286-21.764-18.286H332.6V79.478h16.412V60.3h1.338c3.657,0,7.047,7.493,9.009,11.061,3.657,6.511,7.225,9.187,14.628,9.187,3.3,0,6.69-1.07,8.384-2.408l.089-.178L370.331,58.428c-.178-.089-.268-.268-.357-.357m-12.488-8.652h-8.474V38.269h8.474a5.411,5.411,0,0,1,5.709,5.173v.535c0,3.568-2.676,5.352-5.709,5.441",
    transform: "translate(-31.356 -2.155)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2657",
    "data-name": "Caminho 2657",
    d: "M151.883,106.809a8.29,8.29,0,0,1-2.5,5.976,9.074,9.074,0,0,1-6.244,2.5,8.741,8.741,0,1,1,0-17.483,9.034,9.034,0,0,1,6.957,3.211v.268l-2.5,2.052h-.357a5.2,5.2,0,0,0-4.1-1.962,4.816,4.816,0,0,0-4.817,4.906v.178a4.857,4.857,0,0,0,4.906,5,5.147,5.147,0,0,0,3.3-1.16,4.286,4.286,0,0,0,1.249-2.23h-4.46v-2.944h8.206l.357.268v1.427",
    transform: "translate(-12.778 -9.193)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2658",
    "data-name": "Caminho 2658",
    d: "M157,106.641c0-5,4.014-8.741,9.187-8.741s9.187,3.746,9.187,8.741-4.014,8.741-9.187,8.741S157,111.637,157,106.641m14.272,0a5.084,5.084,0,1,0-5.084,5.084h0a4.913,4.913,0,0,0,5.084-4.817v-.268",
    transform: "translate(-14.923 -9.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2659",
    "data-name": "Caminho 2659",
    d: "M196.683,98.568l-7.582,16.5h-2.319l-7.582-16.5.178-.268h4.1l4.46,10.7,4.638-10.7H196.5Z",
    transform: "translate(-17.037 -9.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2660",
    "data-name": "Caminho 2660",
    d: "M206.3,101.6v3.479h6.333V108.2H206.3v3.568h8.206v3.3H202.2V98.3h12.309v3.3Z",
    transform: "translate(-19.248 -9.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2661",
    "data-name": "Caminho 2661",
    d: "M234.515,114.712l-.178.268h-4.014l-3.39-6.333h-2.319v6.333H220.6V98.3h7.225c4.281,0,6.511,2.052,6.511,5.352a4.823,4.823,0,0,1-3.3,4.638Zm-9.9-8.741h3.3a2.11,2.11,0,0,0,2.319-1.873v-.268a2.135,2.135,0,0,0-2.141-2.23h-3.479Z",
    transform: "translate(-20.992 -9.249)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2662",
    "data-name": "Caminho 2662",
    d: "M255.574,98.3v16.858h-2.5l-8.563-10.079v9.99H240.5V98.3H243l8.474,9.99V98.3Z",
    transform: "translate(-22.879 -9.247)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2663",
    "data-name": "Caminho 2663",
    d: "M261.7,106.641c0-5,4.014-8.741,9.187-8.741s9.187,3.746,9.187,8.741-4.014,8.741-9.187,8.741a8.861,8.861,0,0,1-9.187-8.741m14.272,0a5.084,5.084,0,1,0-10.169,0,5.026,5.026,0,0,0,5.084,5.084h0a4.912,4.912,0,0,0,5.084-4.817v-.268",
    transform: "translate(-24.876 -9.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2664",
    "data-name": "Caminho 2664",
    d: "M310.245,106.6c0,5.084-3.389,8.385-8.831,8.385H294.1V98.3h7.314c5.441,0,8.831,3.3,8.831,8.3m-4.1,0c0-3.211-1.962-5.084-4.906-5.084h-3.211V111.68h3.211c2.944,0,4.906-1.873,4.906-5.084",
    transform: "translate(-27.971 -9.249)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2665",
    "data-name": "Caminho 2665",
    d: "M315.4,106.641c0-5,4.014-8.741,9.187-8.741s9.188,3.746,9.188,8.741-4.014,8.741-9.188,8.741-9.187-3.746-9.187-8.741m14.272,0a5.04,5.04,0,1,0-5.084,5h.089a4.913,4.913,0,0,0,5.084-4.817.276.276,0,0,1-.089-.178",
    transform: "translate(-29.98 -9.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2666",
    "data-name": "Caminho 2666",
    d: "M351.814,101.6v3.479h6.333V108.2h-6.333v3.568h8.3v3.3H347.8V98.3h12.22v3.3Z",
    transform: "translate(-33.108 -9.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2667",
    "data-name": "Caminho 2667",
    d: "M364.7,112.249v-.268l1.962-2.319h.268a6.586,6.586,0,0,0,4.638,2.23c1.695,0,2.676-.714,2.676-1.695,0-1.427-1.606-1.606-3.657-2.23-2.319-.714-5.084-2.052-5.084-5.174,0-2.944,2.587-5,6.333-5a8.533,8.533,0,0,1,6.333,2.5v.268l-1.962,2.23h-.268a6.27,6.27,0,0,0-4.014-1.873c-1.338,0-2.23.535-2.23,1.516,0,1.07,1.249,1.516,2.676,2.051,2.854.892,6.155,1.784,6.155,5.53,0,3.3-2.944,5.084-6.6,5.084a8.562,8.562,0,0,1-7.225-2.854",
    transform: "translate(-34.705 -9.194)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2668",
    "data-name": "Caminho 2668",
    d: "M391.677,115.069h-4.014V101.6H382.4V98.3h14.628v3.3h-5.352Z",
    transform: "translate(-36.382 -9.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2669",
    "data-name": "Caminho 2669",
    d: "M416.018,114.7l-.179.357h-4.1l-1.249-2.944h-7.136l-1.249,2.944h-3.925L398,114.7l7.76-16.5h2.5Zm-6.6-5.441-2.319-5.709-2.408,5.709Z",
    transform: "translate(-37.835 -9.238)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2670",
    "data-name": "Caminho 2670",
    d: "M437.745,106.6c0,5.084-3.39,8.385-8.831,8.385H421.6V98.3h7.314c5.441,0,8.831,3.3,8.831,8.3m-4.1,0c0-3.211-1.962-5.084-4.817-5.084h-3.211V111.68h3.211c2.943,0,4.906-1.873,4.817-5.084",
    transform: "translate(-40.097 -9.249)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2671",
    "data-name": "Caminho 2671",
    d: "M443,106.641c0-5,4.014-8.741,9.187-8.741s9.187,3.746,9.187,8.741-4.014,8.741-9.187,8.741S443,111.637,443,106.641m14.272,0a5.084,5.084,0,1,0-5.084,5.084h0a4.913,4.913,0,0,0,5.084-4.817v-.268",
    transform: "translate(-42.109 -9.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2672",
    "data-name": "Caminho 2672",
    d: "M88.663,56.685c.624-5.173,4.282-8.741,8.563-11.507l.8-.446L83.668,26.626l-.268-.089c-1.695-.357-3.39-.624-5.084-.892-5.173-.714-8.92-1.16-12.131-1.516l-2.676-.178H63.42l-.8-.089H62.26l-5.887-.268H55.124c-7.225-.178-13.558.089-18.107.357-1.606.089-11.685,1.07-13.647,1.338H23.1c-2.319.357-7.047,1.07-8.741,1.338L0,44.733l.8.446c4.281,2.676,7.939,6.333,8.563,11.507s-2.23,11.061-4.192,15.7c-2.587,6.244-5,12.4-5,19.267A18.461,18.461,0,0,0,.8,96.022c1.427,4.549,4.906,8.206,8.652,11.15a96.134,96.134,0,0,0,14.182,8.741c5.084,2.676,10.258,5.263,15.164,8.206,3.3,1.962,7.582,4.906,9.366,8.385l.714,1.427.714-1.427c1.784-3.479,6.155-6.333,9.366-8.385,4.906-2.944,10.079-5.53,15.164-8.206a96.134,96.134,0,0,0,14.182-8.741c3.746-2.944,7.225-6.6,8.652-11.15a14.394,14.394,0,0,0,.624-4.371c0-6.868-2.408-13.023-5-19.267-1.784-4.638-4.549-10.525-3.925-15.7",
    transform: "translate(0 -0.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2673",
    "data-name": "Caminho 2673",
    d: "M74.4,3.738l2.944.446V2.4Z",
    transform: "translate(-8.037 -0.259)",
    fill: "#ead7b1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2674",
    "data-name": "Caminho 2674",
    d: "M45.6,1.3V2.995l1.695-.178Z",
    transform: "translate(-4.926 -0.14)",
    fill: "#ead7b1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2675",
    "data-name": "Caminho 2675",
    d: "M62.3,2.806l1.606.089V1.2Z",
    transform: "translate(-6.73 -0.13)",
    fill: "#ead7b1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2129",
    "data-name": "Grupo 2129",
    transform: "translate(21.229 0.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2128",
    "data-name": "Grupo 2128",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_16993",
    "data-name": "Ret\\xE2ngulo 16993",
    width: 55.213,
    height: 8.028,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2131",
    "data-name": "Grupo 2131",
    transform: "translate(22.299 5.887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2130",
    "data-name": "Grupo 2130",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_16994",
    "data-name": "Ret\\xE2ngulo 16994",
    width: 52.984,
    height: 4.638,
    transform: "translate(0 0.089)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2133",
    "data-name": "Grupo 2133",
    transform: "translate(21.14 8.831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2132",
    "data-name": "Grupo 2132",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_16995",
    "data-name": "Ret\\xE2ngulo 16995",
    width: 55.659,
    height: 14.896,
    transform: "translate(0.089 0)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2679",
    "data-name": "Caminho 2679",
    d: "M58.1,23.021l-8.3.089a26.376,26.376,0,0,1,.535-4.638,5.737,5.737,0,0,1,2.052-2.944,3.618,3.618,0,0,1,3.033-.446,4.219,4.219,0,0,1,2.319,1.962,7.938,7.938,0,0,1,1.07,3.39,13.412,13.412,0,0,1,0,2.676Z",
    transform: "translate(-5.379 -1.614)",
    fill: "#ead7b1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2680",
    "data-name": "Caminho 2680",
    d: "M68.408,12.5c-1.338.089-2.5.892-2.408,1.962s.714,6.065.714,6.065l5.352.357-.981-6.868S69.746,12.41,68.408,12.5",
    transform: "translate(-7.129 -1.35)",
    fill: "#ead7b1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2135",
    "data-name": "Grupo 2135",
    transform: "translate(4.727 27.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2134",
    "data-name": "Grupo 2134",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_16996",
    "data-name": "Ret\\xE2ngulo 16996",
    width: 88.038,
    height: 97.493,
    transform: "translate(0 -0.089)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2682",
    "data-name": "Caminho 2682",
    d: "M20.368,50.9l-.892,2.676H16.8l2.23,1.695-.892,2.676,2.23-1.695,2.141,1.695-.8-2.676,2.23-1.695H21.171Z",
    transform: "translate(-1.815 -4.844)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2683",
    "data-name": "Caminho 2683",
    d: "M20.368,50.9l-.892,2.676H16.8l2.23,1.695-.892,2.676,2.23-1.695,2.141,1.695-.8-2.676,2.23-1.695H21.171Z",
    transform: "translate(-1.815 -4.844)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2684",
    "data-name": "Caminho 2684",
    d: "M17.768,71.3l-.8,2.676H14.2l2.23,1.695-.8,2.676,2.141-1.695L20,78.347l-.892-2.676,2.23-1.695H18.571Z",
    transform: "translate(-1.534 -6.786)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2685",
    "data-name": "Caminho 2685",
    d: "M17.768,71.3l-.8,2.676H14.2l2.23,1.695-.8,2.676,2.141-1.695L20,78.347l-.892-2.676,2.23-1.695H18.571Z",
    transform: "translate(-1.534 -6.786)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2686",
    "data-name": "Caminho 2686",
    d: "M14.468,89.6l-.8,2.676H10.9l2.23,1.695-.892,2.676,2.23-1.695,2.23,1.695-.892-2.676,2.23-1.695H15.271Z",
    transform: "translate(-1.177 -8.527)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2687",
    "data-name": "Caminho 2687",
    d: "M14.468,89.6l-.8,2.676H10.9l2.23,1.695-.892,2.676,2.23-1.695,2.23,1.695-.892-2.676,2.23-1.695H15.271Z",
    transform: "translate(-1.177 -8.527)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2688",
    "data-name": "Caminho 2688",
    d: "M54.068,121.5l-.8,2.676-2.765-.089,2.23,1.695-.8,2.676,2.141-1.695,2.23,1.695-.892-2.676,2.23-1.695-2.676.089Z",
    transform: "translate(-5.455 -11.334)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2689",
    "data-name": "Caminho 2689",
    d: "M54.068,121.5l-.8,2.676-2.765-.089,2.23,1.695-.8,2.676,2.141-1.695,2.23,1.695-.892-2.676,2.23-1.695-2.676.089Z",
    transform: "translate(-5.455 -11.334)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2690",
    "data-name": "Caminho 2690",
    d: "M72.468,114l-.892,2.676H68.9l2.23,1.695-.892,2.676,2.23-1.695,2.141,1.695-.8-2.676,2.141-1.695H73.271Z",
    transform: "translate(-7.443 -10.85)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2691",
    "data-name": "Caminho 2691",
    d: "M72.468,114l-.892,2.676H68.9l2.23,1.695-.892,2.676,2.23-1.695,2.141,1.695-.8-2.676,2.141-1.695H73.271Z",
    transform: "translate(-7.443 -10.85)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2692",
    "data-name": "Caminho 2692",
    d: "M35.568,114l.8,2.676h2.765l-2.23,1.695.892,2.676-2.23-1.695-2.23,1.695.892-2.676L32,116.676h2.676Z",
    transform: "translate(-3.457 -10.85)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2693",
    "data-name": "Caminho 2693",
    d: "M35.568,114l.8,2.676h2.765l-2.23,1.695.892,2.676-2.23-1.695-2.23,1.695.892-2.676L32,116.676h2.676Z",
    transform: "translate(-3.457 -10.85)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2694",
    "data-name": "Caminho 2694",
    d: "M20.968,104.3l.8,2.676h2.765l-2.23,1.606.892,2.676-2.23-1.606-2.23,1.606.892-2.676-2.23-1.606h2.765Z",
    transform: "translate(-1.88 -9.928)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2695",
    "data-name": "Caminho 2695",
    d: "M20.968,104.3l.8,2.676h2.765l-2.23,1.606.892,2.676-2.23-1.606-2.23,1.606.892-2.676-2.23-1.606h2.765Z",
    transform: "translate(-1.88 -9.928)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2137",
    "data-name": "Grupo 2137",
    transform: "translate(22.194 36.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2136",
    "data-name": "Grupo 2136",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_16997",
    "data-name": "Ret\\xE2ngulo 16997",
    width: 54.054,
    height: 34.43,
    transform: "translate(-0.43)",
    fill: "url(#radial-gradient-2)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2697",
    "data-name": "Caminho 2697",
    d: "M24.889,76.8H39.874v.624H24.8v-.089h0l.089-.535",
    transform: "translate(-2.679 -7.358)",
    fill: "#caa52e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2698",
    "data-name": "Caminho 2698",
    d: "M24.889,76.8H39.874v.624H24.8v-.089h0Z",
    transform: "translate(-2.679 -7.358)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2699",
    "data-name": "Caminho 2699",
    d: "M25,73.5l14.9,2.944-.178.624L25,74.124V73.5",
    transform: "translate(-2.701 -7.021)",
    fill: "#caa52e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2700",
    "data-name": "Caminho 2700",
    d: "M25,73.5l14.9,2.944-.178.624L25,74.124Z",
    transform: "translate(-2.701 -7.021)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2701",
    "data-name": "Caminho 2701",
    d: "M25.389,70.1l14.628,5.976-.268.624L25.3,70.814a1.739,1.739,0,0,1,.089-.714",
    transform: "translate(-2.733 -6.675)",
    fill: "#caa52e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2702",
    "data-name": "Caminho 2702",
    d: "M25.389,70.1l14.628,5.976-.268.624L25.3,70.814A1.739,1.739,0,0,1,25.389,70.1Z",
    transform: "translate(-2.733 -6.675)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2703",
    "data-name": "Caminho 2703",
    d: "M25.989,66.4l14.093,9.277-.357.535L25.9,67.114c0-.268.089-.446.089-.714",
    transform: "translate(-2.798 -6.3)",
    fill: "#caa52e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2704",
    "data-name": "Caminho 2704",
    d: "M25.989,66.4l14.093,9.277-.357.535L25.9,67.114C25.9,66.846,25.989,66.668,25.989,66.4Z",
    transform: "translate(-2.798 -6.3)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2705",
    "data-name": "Caminho 2705",
    d: "M27.078,62.4l13.2,12.934-.446.446L26.9,63.114l.178-.714",
    transform: "translate(-2.906 -5.896)",
    fill: "#caa52e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2706",
    "data-name": "Caminho 2706",
    d: "M27.078,62.4l13.2,12.934-.446.446L26.9,63.114Z",
    transform: "translate(-2.906 -5.896)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2707",
    "data-name": "Caminho 2707",
    d: "M28.857,57.8,40.542,74.926l-.535.357L28.5,58.514l.357-.714",
    transform: "translate(-3.079 -5.433)",
    fill: "#caa52e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2708",
    "data-name": "Caminho 2708",
    d: "M28.857,57.8,40.542,74.926l-.535.357L28.5,58.514Z",
    transform: "translate(-3.079 -5.433)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2709",
    "data-name": "Caminho 2709",
    d: "M31.646,52.7l9.187,21.675-.624.268L31.2,53.324a3.776,3.776,0,0,0,.446-.624",
    transform: "translate(-3.37 -4.923)",
    fill: "#caa52e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2710",
    "data-name": "Caminho 2710",
    d: "M31.646,52.7l9.187,21.675-.624.268L31.2,53.324C31.378,53.146,31.468,52.878,31.646,52.7Z",
    transform: "translate(-3.37 -4.923)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2711",
    "data-name": "Caminho 2711",
    d: "M35.835,47.6l5.441,26.313L40.652,74,35.3,48.046a2.364,2.364,0,0,0,.535-.446",
    transform: "translate(-3.813 -4.417)",
    fill: "#caa52e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2712",
    "data-name": "Caminho 2712",
    d: "M35.835,47.6l5.441,26.313L40.652,74,35.3,48.046A2.364,2.364,0,0,0,35.835,47.6Z",
    transform: "translate(-3.813 -4.417)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2713",
    "data-name": "Caminho 2713",
    d: "M41.824,43.2l.089,30.327h-.624L41.2,43.557l.624-.357",
    transform: "translate(-4.45 -3.984)",
    fill: "#caa52e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2714",
    "data-name": "Caminho 2714",
    d: "M41.824,43.2l.089,30.327h-.624L41.2,43.557Z",
    transform: "translate(-4.45 -3.984)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2715",
    "data-name": "Caminho 2715",
    d: "M48.347,40.6,41.924,73.336l-.624-.089,6.422-32.468.624-.178",
    transform: "translate(-4.461 -3.728)",
    fill: "#caa52e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2716",
    "data-name": "Caminho 2716",
    d: "M48.347,40.6,41.924,73.336l-.624-.089,6.422-32.468Z",
    transform: "translate(-4.461 -3.728)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2717",
    "data-name": "Caminho 2717",
    d: "M55.572,40.2,41.924,73.382l-.624-.268L54.947,40.2h.624",
    transform: "translate(-4.461 -3.689)",
    fill: "#caa52e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2718",
    "data-name": "Caminho 2718",
    d: "M55.572,40.2,41.924,73.382l-.624-.268L54.947,40.2Z",
    transform: "translate(-4.461 -3.689)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2719",
    "data-name": "Caminho 2719",
    d: "M62.886,42.178l-21.051,31.4-.535-.357L62.262,42l.624.178",
    transform: "translate(-4.461 -3.865)",
    fill: "#caa52e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2720",
    "data-name": "Caminho 2720",
    d: "M62.886,42.178l-21.051,31.4-.535-.357L62.262,42Z",
    transform: "translate(-4.461 -3.865)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2721",
    "data-name": "Caminho 2721",
    d: "M69.219,46.746,41.746,74.13l-.446-.446L68.773,46.3l.446.446",
    transform: "translate(-4.461 -4.287)",
    fill: "#caa52e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2722",
    "data-name": "Caminho 2722",
    d: "M69.219,46.746,41.746,74.13l-.446-.446L68.773,46.3Z",
    transform: "translate(-4.461 -4.287)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2723",
    "data-name": "Caminho 2723",
    d: "M74.136,53.224,41.757,74.81l-.357-.535L73.868,52.6a4.345,4.345,0,0,0,.268.624",
    transform: "translate(-4.472 -4.912)",
    fill: "#caa52e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2724",
    "data-name": "Caminho 2724",
    d: "M74.136,53.224,41.757,74.81l-.357-.535L73.868,52.6A.81.81,0,0,0,74.136,53.224Z",
    transform: "translate(-4.472 -4.912)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2725",
    "data-name": "Caminho 2725",
    d: "M77.347,60.824,41.668,75.72,41.4,75.1,77.168,60.2a1.654,1.654,0,0,1,.178.624",
    transform: "translate(-4.472 -5.673)",
    fill: "#caa52e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2726",
    "data-name": "Caminho 2726",
    d: "M77.347,60.824,41.668,75.72,41.4,75.1,77.168,60.2A1.654,1.654,0,0,1,77.347,60.824Z",
    transform: "translate(-4.472 -5.673)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2727",
    "data-name": "Caminho 2727",
    d: "M79.32,68.924,41.678,76.6l-.178-.624L79.231,68.3l.089.624",
    transform: "translate(-4.483 -6.491)",
    fill: "#caa52e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2728",
    "data-name": "Caminho 2728",
    d: "M79.32,68.924,41.678,76.6l-.178-.624L79.231,68.3Z",
    transform: "translate(-4.483 -6.491)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2729",
    "data-name": "Caminho 2729",
    d: "M79.855,77.124,41.5,77.392v-.624L79.855,76.5v.624",
    transform: "translate(-4.483 -7.327)",
    fill: "#caa52e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2730",
    "data-name": "Caminho 2730",
    d: "M79.855,77.124,41.5,77.392v-.624L79.855,76.5Z",
    transform: "translate(-4.483 -7.327)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2731",
    "data-name": "Caminho 2731",
    d: "M40.412,66.4a9.746,9.746,0,0,1,9.812,9.633H30.6A9.8,9.8,0,0,1,40.412,66.4",
    transform: "translate(-3.305 -6.301)",
    fill: "#caa52e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2732",
    "data-name": "Caminho 2732",
    d: "M40.509,67.3a8.8,8.8,0,0,1,9.009,8.652H31.5A8.908,8.908,0,0,1,40.509,67.3h0",
    transform: "translate(-3.403 -6.394)",
    fill: "#facb13",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2139",
    "data-name": "Grupo 2139",
    transform: "translate(22.121 70.206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2138",
    "data-name": "Grupo 2138",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_16998",
    "data-name": "Ret\\xE2ngulo 16998",
    width: 48.434,
    height: 33.449,
    transform: "translate(0.089 -0.357)",
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2141",
    "data-name": "Grupo 2141",
    transform: "translate(21.817 69.852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2140",
    "data-name": "Grupo 2140",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_16999",
    "data-name": "Ret\\xE2ngulo 16999",
    width: 34.252,
    height: 34.163,
    transform: "translate(-1.034 0)",
    fill: "url(#linear-gradient-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2143",
    "data-name": "Grupo 2143",
    transform: "translate(48.524 54.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2142",
    "data-name": "Grupo 2142",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17000",
    "data-name": "Ret\\xE2ngulo 17000",
    width: 26.849,
    height: 15.253,
    transform: "translate(0 0.089)",
    fill: "url(#linear-gradient-6)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2736",
    "data-name": "Caminho 2736",
    d: "M36.976,96.861c-3.568-7.225-1.695-11.6,3.211-14.361-2.23,3.925,1.07,7.314,5.709,10.971a24.078,24.078,0,0,0-8.831,3.3Z",
    transform: "translate(-3.794 -7.786)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2145",
    "data-name": "Grupo 2145",
    transform: "translate(46.538 70.179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2144",
    "data-name": "Grupo 2144",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17001",
    "data-name": "Ret\\xE2ngulo 17001",
    width: 30.506,
    height: 23.013,
    transform: "translate(-1.671 -0.089)",
    fill: "url(#linear-gradient-7)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2147",
    "data-name": "Grupo 2147",
    transform: "translate(61.279 62.611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2146",
    "data-name": "Grupo 2146",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17002",
    "data-name": "Ret\\xE2ngulo 17002",
    width: 14.182,
    height: 6.69,
    transform: "translate(0)",
    fill: "url(#linear-gradient-8)"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17003",
    "data-name": "Ret\\xE2ngulo 17003",
    width: 3.568,
    height: 1.873,
    transform: "translate(35.233 51.727)",
    fill: "#facb13"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17004",
    "data-name": "Ret\\xE2ngulo 17004",
    width: 3.568,
    height: 1.873,
    transform: "translate(35.233 51.727)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2739",
    "data-name": "Caminho 2739",
    d: "M55.878,52.694a17.3,17.3,0,0,1,6.779.8c1.695.624,2.319.624,3.925,2.052l-2.319,1.516c-2.408-2.676-5.352-3.122-8.385-4.014-1.338-.446-1.338-.357,0-.357",
    transform: "translate(-5.928 -5.024)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2740",
    "data-name": "Caminho 2740",
    d: "M66.119,55.615c1.873.178,4.1-1.338,5-1.516.357-.089.892.535.624.714a7.906,7.906,0,0,1-1.516.714,9.667,9.667,0,0,1,1.695-.714c.446.089.714.8.535.981a11.426,11.426,0,0,0-1.962.624,12.632,12.632,0,0,1,1.962-.624c.268,0,.535.8.178.981-1.07.714-2.408.714-3.479,1.16C69.6,59.54,70.669,61.5,70.579,63.2c-.089,2.676-1.516,5.173-1.962,7.671-.178.981-.089,1.249-.268.089-.535-3.211-.8-9.009-2.319-11.15a5.9,5.9,0,0,0-3.657-1.249c-.446.089-1.427.357-1.873.446.178-.8.714-2.944,2.23-2.765Z",
    transform: "translate(-6.535 -5.083)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2741",
    "data-name": "Caminho 2741",
    d: "M67.546,87.6l-.089.892,1.16.8v-.981l-1.07-.714ZM67.1,102.764v.892l.089.089h1.16Zm0-1.695v.892l1.962,1.516v-.892Zm.089-1.695v.892l1.962,1.427V100.8Zm0-1.695-.089.892,1.784,1.338v-.981Zm.089-1.695v.892l1.695,1.249v-.892Zm.089-1.695v.892l1.606,1.16V95.36Zm0-1.695v.892l1.427,1.07v-.981Zm.089-1.695-.089.892,1.338.981v-.981Zm.089-1.695-.089.892,1.249.892-.089-.981Z",
    transform: "translate(-7.248 -8.248)",
    fill: "#ab9276",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2742",
    "data-name": "Caminho 2742",
    d: "M66.9,104.39v.892l.089.089h1.16Zm.089-1.695v.8l1.962,1.516v-.892ZM67.078,101v.892l1.873,1.427v-.892Z",
    transform: "translate(-7.227 -9.64)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2149",
    "data-name": "Grupo 2149",
    transform: "translate(33.182 57.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2148",
    "data-name": "Grupo 2148",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17005",
    "data-name": "Ret\\xE2ngulo 17005",
    width: 7.849,
    height: 11.863,
    fill: "url(#linear-gradient-9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2151",
    "data-name": "Grupo 2151",
    transform: "translate(35.322 48.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2150",
    "data-name": "Grupo 2150",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17006",
    "data-name": "Ret\\xE2ngulo 17006",
    width: 4.014,
    height: 8.652,
    transform: "translate(-0.089 -0.079)",
    fill: "url(#linear-gradient-10)"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17007",
    "data-name": "Ret\\xE2ngulo 17007",
    width: 3.211,
    height: 1.516,
    transform: "translate(35.412 51.815)",
    fill: "#facb13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2745",
    "data-name": "Caminho 2745",
    d: "M40.057,12.4c1.338.089,2.5.892,2.408,1.962s-.714,6.065-.714,6.065l-5.352.357.981-6.868c0,.089,1.338-1.516,2.676-1.516",
    transform: "translate(-3.932 -1.339)",
    fill: "#ead7b1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2746",
    "data-name": "Caminho 2746",
    d: "M38.935,14.8c-.178,1.873-.446,3.033-.535,4.906.892-.089,1.606-.089,2.319-.178.178-1.784.446-3.122.624-4.906-.446-.981-1.695-.892-2.408.178",
    transform: "translate(-4.148 -1.505)",
    fill: "#6e4e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2747",
    "data-name": "Caminho 2747",
    d: "M70.544,19.7c-.178-1.784-.357-3.122-.535-4.906-.714-1.07-1.962-1.249-2.408-.178.178,1.784.357,3.122.624,4.906a16.381,16.381,0,0,0,2.319.178",
    transform: "translate(-7.302 -1.501)",
    fill: "#6e4e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2748",
    "data-name": "Caminho 2748",
    d: "M57.811,22.979v-.714c-.178-2.319-.357-6.065-3.3-6.065s-3.033,3.836-3.211,6.155v.535Z",
    transform: "translate(-5.541 -1.75)",
    fill: "#6e4e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2749",
    "data-name": "Caminho 2749",
    d: "M51.5,13.558c3.836,0,3.925,4.549,4.192,7.4v.268h.714v-.178h0l-.268-2.408h1.784l.268,2.408h0l.089.178h.714v-.178h0l-.268-2.408,3.122.089.089.981,1.427.089c.8.089,1.606.089,2.319.178l2.141.178-.089-1.07c1.338.089,2.676.178,4.014.357l.624,2.587.089.446h.714l-.089-.624-.535-2.23,4.906.624,1.07,2.408.089.268h0l.089.178.892.089v-.178h0l-5.352-12.22,1.873.268,1.962-1.695,1.427-3.122A15.922,15.922,0,0,0,79.6,2.676c-1.07-.178-7.225-1.427-7.76-1.427L67.289,3.3V.714L59.618.089h0l-2.676,2.5H55.247V0H47.576V2.587l-1.606.089L43.295.178,35.535.8V3.3L31.164,1.338c-.535-.089-6.6,1.16-7.671,1.338a15.643,15.643,0,0,0,.089,3.568c1.784,3.657.446,2.319,3.657,4.638l1.516-.178L23.493,23.013v.268l.8-.089.089-.178h0l1.249-2.854h0l4.906-.624-.714,2.676v.624h.624l.268-1.249.535-2.052c1.249-.089,2.408-.268,3.657-.357l-.089.981,2.052-.178c.8-.089,1.606-.089,2.319-.178l1.338-.178.089-.892c1.16-.089,2.408-.089,3.568-.178l-.178,1.962-.089.892h.714v-.357h0l.268-2.5,1.784-.089.089-.714-5.887.357.357-2.5,6.511-.268a17.843,17.843,0,0,0-1.07,5.352l-.178.714h.714v-.357h0c.357-2.854.535-7.493,4.282-7.493M61.67,11.685c-3.3-.178-6.511-.268-9.812-.268V8.92c3.746,0,7.493.178,11.239.446l.178,1.338-.268.089a2.546,2.546,0,0,0-1.338.892m-.624,1.695c.089.535.089.981.178,1.427l-3.033-.089-.178-2.587c1.07,0,2.141.089,3.211.178l-.089.178-.178.446Zm4.638,5.709c-.8-.089-1.606-.089-2.319-.178l-.714-.089-.089-.714c-.178-1.606-.446-3.3-.624-4.906v-.268l.089-.178a2.17,2.17,0,0,1,1.338-1.16,2.337,2.337,0,0,1,2.587,1.249l.089.178V13.2c.178,1.606.446,3.3.535,4.906l.089,1.07ZM66.932,13.2l-.089-.357h0c1.07.089,2.141.178,3.122.357l.624,2.5c-1.16-.089-2.319-.178-3.479-.357a15.975,15.975,0,0,0-.178-2.141M77.1,19.356h-.089c-3.122-.446-6.244-.714-9.366-.981v-.268l-.268-2.141c2.854.268,5.8.535,8.652.981Zm-1.427-3.122h-.089l-4.1-.535-.624-2.5,3.746.446Zm-1.427-3.3h-.089l-7.671-.8a3.653,3.653,0,0,0-2.408-1.338L63.81,9.455c3.122.268,6.244.624,9.277,1.07Zm-2.5-10.7V3.836c-.892-.089-1.873-.268-2.765-.446ZM59.707,1.16V2.676H58.1Zm-16.412,0L44.9,2.676l-1.606.089ZM31.164,2.319l2.854,1.249-2.854.357ZM25.277,7.76C24.028,5.352,24.3,6.244,24.3,3.39c2.052-.357,4.014-.714,6.065-1.07v2.5c2.052-.268,4.014-.535,6.065-.714V1.516c2.052-.178,4.014-.357,6.065-.446V3.657c1.962-.089,3.925-.178,5.976-.268V.8h6.065V3.39c2.052,0,4.014.089,6.065.178V.981c2.052.089,4.014.268,6.065.446V4.014c1.962.178,4.014.446,6.065.714V2.319c1.962.357,4.014.714,6.065,1.07,0,2.944.268,1.873-1.07,4.46A162.5,162.5,0,0,0,50.7,5.619,174.572,174.572,0,0,0,25.277,7.76Zm2.23,2.23a16.407,16.407,0,0,1-1.962-1.516,158.443,158.443,0,0,1,51.913.178l-1.695,1.516L66.932,8.92A153.447,153.447,0,0,0,27.507,9.99m2.141.624c3.122-.446,6.333-.8,9.455-1.07l-.268,1.16a3.591,3.591,0,0,0-2.854,1.427l-7.4.8ZM28.31,13.647h0l3.746-.446-.624,2.587-4.281.535ZM35,18.107v.357c-3.033.268-6.065.535-9.1.981l1.07-2.5h0c2.765-.357,5.53-.714,8.3-.892A8.645,8.645,0,0,0,35,18.107m.535-4.906-.268,2.141-3.122.268.714-2.587,2.676-.268Zm5.084.089c-.178,1.695-.446,3.3-.624,4.906l-.089.714L39.1,19c-.8.089-1.606.089-2.319.178l-1.07.089L35.8,18.2c.178-1.606.446-3.3.535-4.906v-.178l.089-.178A2.515,2.515,0,0,1,39.1,11.685a2.279,2.279,0,0,1,1.338,1.07l.089.178Zm.178-1.606a2.958,2.958,0,0,0-1.249-.892l.268-1.427C43.562,9.1,47.4,8.92,51.144,8.92v2.408c-3.39,0-6.868.089-10.347.357m3.836,3.122c-1.16,0-2.23.089-3.39.178a9.934,9.934,0,0,0,.178-1.516l.089-.446-.178-.535-.089-.089c1.16-.089,2.408-.089,3.568-.178Zm.714,0,.178-2.587c3.925-.089,7.849-.178,11.774,0l.268,2.5-2.676-.089a1.793,1.793,0,0,1,.357.714l6.065.268.357,2.5L56.05,17.84v.268c-.446-2.676-1.427-5.263-4.638-5.263a3.765,3.765,0,0,0-3.39,1.784Z",
    transform: "translate(-2.531)",
    fill: "#6e4e32"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17008",
    "data-name": "Ret\\xE2ngulo 17008",
    width: 1.873,
    height: 1.784,
    transform: "translate(36.304 61.674)",
    fill: "#405965"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2750",
    "data-name": "Caminho 2750",
    d: "M44.253,97.648a.581.581,0,0,0,.178-.8c0-.089-.089-.089-.178-.178H42.736v-.892a.384.384,0,0,0-.357-.357h-.8a.384.384,0,0,0-.357.357h0v.892H37.741A24.5,24.5,0,0,1,45.5,93.9l1.427-.268-1.16-.892c-2.052-1.606-5.8-4.46-6.065-7.314a4.463,4.463,0,0,1,.624-2.587L41.577,80.7l-2.23,1.16c-6.155,3.39-6.244,9.1-3.39,14.807h-.892v-.535h-1.16v.535H32.568c-.357.268-.357.624,0,.981a32.158,32.158,0,0,0,11.685,0M39.7,82.484c-2.23,3.925.981,7.136,5.709,10.793a22.671,22.671,0,0,0-8.652,3.3C33.37,89.8,34.8,85.16,39.7,82.484",
    transform: "translate(-3.489 -7.585)",
    fill: "#405965"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2751",
    "data-name": "Caminho 2751",
    d: "M63.057,57.4c-.178,0-.357.089-.357.268s.089.357.268.357h0c.178,0,.357-.089.357-.268h0c0-.178-.089-.268-.268-.357h0",
    transform: "translate(-6.773 -5.499)",
    fill: "#405965"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2752",
    "data-name": "Caminho 2752",
    d: "M88.674,56.685c.624-5.173,4.282-8.741,8.563-11.507l.8-.446L83.678,26.626l-.268-.089c-1.695-.357-3.39-.624-5.084-.892-5.173-.714-8.92-1.16-12.131-1.516L63.52,23.95h-.089l-.8-.089h-.357l-5.887-.268H55.046c-7.225-.178-13.558.089-18.107.357-1.606.089-11.685,1.07-13.558,1.338h-.268c-2.319.357-7.047,1.07-8.741,1.338L.1,44.733l.8.446c4.281,2.676,7.939,6.333,8.563,11.507s-2.319,11.061-4.282,15.7c-2.587,6.244-5,12.4-5,19.267a14.8,14.8,0,0,0,.624,4.371c1.427,4.549,4.906,8.206,8.652,11.15a96.134,96.134,0,0,0,14.182,8.741c5.084,2.676,10.258,5.263,15.164,8.206,3.3,1.962,7.582,4.906,9.366,8.3l.714,1.427.714-1.427c1.784-3.39,6.155-6.333,9.366-8.3,4.906-2.944,10.079-5.53,15.164-8.206a96.136,96.136,0,0,0,14.182-8.741c3.746-2.944,7.225-6.6,8.652-11.15a14.392,14.392,0,0,0,.624-4.371c0-6.868-2.408-13.023-5-19.267-1.784-4.638-4.549-10.525-3.925-15.7M48.98,132.058C42.112,118.946.992,111.275.992,91.651s20.783-34.074.268-47.186L14.728,27.339q36.259-6.155,68.5,0L96.7,44.465c-20.516,13.112.178,27.562.178,47.186s-41.031,27.384-47.9,40.407",
    transform: "translate(-0.011 -0.751)",
    fill: "#405965"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2753",
    "data-name": "Caminho 2753",
    d: "M32.1,4.195l3.033-.357L32.1,2.5Z",
    transform: "translate(-3.467 -0.27)",
    fill: "#ead7b1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2754",
    "data-name": "Caminho 2754",
    d: "M89.427,74.379c-2.23-5.441-5-11.685-4.281-17.661.535-4.906,3.211-8.741,6.957-11.863l.624-.535L81.845,30.761l-.268-.089c-21.318-3.836-42.993-3.39-64.312,0l-.357.089L6.206,44.319l.535.535c3.746,3.122,6.422,6.957,6.957,11.863.714,6.065-2.052,12.22-4.371,17.661C7.008,80.087,4.6,85.885,4.6,92.129a12,12,0,0,0,.446,3.122c2.408,7.76,14,13.915,20.872,17.572,5.173,2.765,10.436,5.263,15.342,8.3a43.911,43.911,0,0,1,7.4,5.441l.624.535.535-.535a40.6,40.6,0,0,1,7.4-5.441c5-3.033,10.258-5.619,15.342-8.3,7.4-3.925,21.318-11.15,21.318-20.694.268-6.244-2.141-12.042-4.46-17.75M72.39,112.109c-5.173,2.765-10.436,5.352-15.431,8.385a45.116,45.116,0,0,0-7.493,5.53,45.116,45.116,0,0,0-7.493-5.53c-5-3.033-10.258-5.619-15.431-8.385-6.511-3.479-18.2-9.633-20.516-17.126a11.215,11.215,0,0,1-.446-2.944c0-6.155,2.319-11.863,4.638-17.483S15.3,62.694,14.59,56.45c-.624-5.173-3.479-9.187-7.314-12.4l5.709-7.225L27.256,50.919c-9.009,15.074-6.868,39.336,6.69,49.862a24.485,24.485,0,0,0,15.52,5.173A24.823,24.823,0,0,0,71.052,94.091L83,105.955a113.393,113.393,0,0,1-10.615,6.155M51.875,39.056h.268A24.377,24.377,0,0,1,57.762,40.3h0l.535.178h.089l.624.268h0l.089.089.178.089.178.089a21.419,21.419,0,0,1,4.906,3.033h0l.981.8h0l.268.268.089.089a28.881,28.881,0,0,1,4.014,4.727h0l.089.089h0c.089.178.268.357.357.535h0l-.178-.268.178.178h0v.089h0a29.2,29.2,0,0,1,2.676,5.263h-.178a6.711,6.711,0,0,0-5.8,3.39c0,.089-.357.624-.535.981-.446.8-.981,1.606-1.516,2.408l.268-1.338a1.741,1.741,0,0,1,.089-.624,1.854,1.854,0,0,0,0-.714c0-1.606-.8-3.033-1.249-4.46a12.06,12.06,0,0,0,3.033-.981,1.272,1.272,0,0,0,.178-1.784,3.863,3.863,0,0,0-.089-.446c0-.089-.178-.268-.178-.357a1.075,1.075,0,0,0-.446-.446,1.378,1.378,0,0,0-1.427-.8c-.535.178-.981.357-1.427.535a12.461,12.461,0,0,1-1.516.8c-.178.089-.357.089-.535.178a15.71,15.71,0,0,0-2.052-1.249h0c-.178-.089-.446-.178-.892-.357l-.8-.268A15.246,15.246,0,0,0,53.3,49.4h0c-.535,0-.981-.089-1.695-.089h-.8c-.535,0-1.606-.089-1.695.624s.892.892,1.427,1.07h.089l1.516.357h0a18.176,18.176,0,0,1,4.192,1.516,2.31,2.31,0,0,0-1.695,1.427l-.178.446a7.43,7.43,0,0,0-.357,1.338h0l-.178.892L55,56.717c.446-.089.981-.178,1.427-.268a4.04,4.04,0,0,1,1.427.268h0a5.455,5.455,0,0,1,1.07.446h.089a1.942,1.942,0,0,1,.714.446h0V57.7h0a16.367,16.367,0,0,1,1.07,4.1h0v.089h0c0,.178.089.357.089.624h0c0,.268.089.535.089.714v.357c-.357-.089-.8-.178-1.07-.268l-.268-.089h-.089l-1.427-.357-.714-.178a4.2,4.2,0,0,0-2.944,1.249c-.268.178-.535.446-.8.624a16.841,16.841,0,0,0-1.784,1.784,1.231,1.231,0,0,0-.268.357c-.446.535-.8,1.07-1.249,1.606l-.535.8h0a7.84,7.84,0,0,1-.535.892,8.156,8.156,0,0,0-.624,1.249H42.242V59.3h-2.5l-.089-1.427h.714V55.2h-.624v-.8h.535v-.892a1.9,1.9,0,0,0-1.338-1.784v-.268a1.232,1.232,0,0,0-.892-1.16c-.089,0-.268-.089-.357-.089h-.268a1.235,1.235,0,0,0-.981,1.16v.268a1.94,1.94,0,0,0-1.249,1.784v.892h.535v.8h-.535v2.676H36l-.089,1.427h-2.5V71.167H22.886v-1.16c0-.624.089-.8.089-1.606h0v-.624a16.562,16.562,0,0,1,.446-3.033c0-.178.089-.446.089-.624h0c.178-.981.357-1.695.446-2.408.089-.357.178-.624.268-.981v-.089c.089-.357.178-.714.357-1.249l.535-1.606a10,10,0,0,1,.446-1.16v-.089a18.1,18.1,0,0,1,.981-2.319l.089-.178a25.124,25.124,0,0,1,1.873-3.39h0a25.26,25.26,0,0,1,1.784-2.5l.357-.446.089-.089a14.291,14.291,0,0,1,2.23-2.408l.089-.089a21.233,21.233,0,0,1,3.568-2.765h.089a8.471,8.471,0,0,1,1.516-.892.676.676,0,0,1,.357-.178,22.531,22.531,0,0,1,4.281-1.695h.089a14.256,14.256,0,0,1,1.873-.446,29.321,29.321,0,0,1,4.817-.446h1.338l.357.089h0c0,.178.268.178.535.268M22.886,71.97H48.218a24.726,24.726,0,0,0-2.319.892l-.178.089-.624.357c-.178.089-.446.268-.624.357h0A5.331,5.331,0,0,0,41.706,78.3a12.893,12.893,0,0,0,.357,2.587h0l.089.268h0a6.775,6.775,0,0,0,.357.981c.446,1.07.892,2.052,1.427,3.122L45.1,87.4c1.695,3.211,3.568,6.511,4.371,9.99a10.968,10.968,0,0,1-.268,6.333h0c-.089.268-.178.446-.268.714a2.97,2.97,0,0,1-.268.535h0c-.624,0-1.338-.089-1.962-.089a23.373,23.373,0,0,1-9.99-3.39C26.9,95.34,22.618,82.852,22.886,71.97Zm13.2-10.882v-1.07h1.07v1.07h1.07v-1.07H39.3v1.07h1.07v-1.07h1.07v2.319H33.946V60.018h1.07v1.07Zm1.606-8.831h0c.981,0,1.784.624,1.784,1.338v.178H35.819V53.6a1.719,1.719,0,0,1,1.873-1.338m-.624-.714a.535.535,0,1,1,1.07,0v.089H37.6a1.131,1.131,0,0,0-.535.089ZM38.941,54.4v.8h-.892v-.8Zm-1.606.892h-.892v-.8h.892Zm2.319,1.962H35.819V55.915h3.925ZM38.941,59.3h-2.5l.089-1.427h2.319Zm2.5,6.957H33.946V63.05h7.582Zm0,.714v4.192H38.674V68.848a1,1,0,1,0-1.962-.357v2.676H33.946V66.975Zm7.939,38c2.319-4.817.535-9.723-1.784-14.361-1.338-2.676-2.854-5.263-3.925-7.671a10.536,10.536,0,0,1-1.16-5.441,4.653,4.653,0,0,1,2.052-3.211,17.057,17.057,0,0,1,2.854-1.427h0l.089-.089.446-.178c-2.676,5.084-1.695,9.99,2.5,14.45,2.408,2.5,5.8,3.836,9.366,5l-.178,5.619h3.211v-.535c0-1.338-.089-2.765-.089-4.1a43.681,43.681,0,0,1,5.976,2.319,23.047,23.047,0,0,1-19.356,9.633Zm13.29-22.3,1.07,1.07.357-.357-1.16-1.249a6.432,6.432,0,0,1,2.23,1.873v.357L64.9,86.777l-1.249-1.249-.178-.089-.089-.178a8.573,8.573,0,0,0-.714-2.587m.446,3.033-.535,1.16c0-1.07-.089-2.141-.089-3.211a12.6,12.6,0,0,1,.535,1.962h0Zm.624-3.746,1.07.357.178-.535-1.338-.446a6.947,6.947,0,0,1,1.873.357l.089.089.089.089,1.338,2.319-1.16-.268h0a8.9,8.9,0,0,0-2.141-1.962m2.141-.8H65.7A6,6,0,0,0,63.56,80.8l1.516-.268L64.987,80l-1.784.268,1.606-.8.178-.089h.178l2.587.446Zm-.357-5-.624.268.714-.535Zm-.178.714-.535,2.052v.089h-.089a15.51,15.51,0,0,0-2.408,1.249L64.1,78.3l-.446-.357L62.133,79.73a17.822,17.822,0,0,1,.892-1.873l.089-.089H63.2Zm-5,18.732v-.8l1.962,1.427v.892ZM61.6,97.392H60.349l-.089-.089V96.41Zm.357-13.558v.892l-1.249-.892v-.892Zm-1.16-1.784v-.8h0l1.07.714v.892Zm1.249,3.479v.892l-1.338-1.07v-.892Zm0,1.784V88.2l-1.427-1.07v-.8Zm.089,1.784v.892l-1.516-1.16v-.8Zm0,1.784v.892l-1.695-1.249v-.8Zm.089,1.784v.892l-1.784-1.338v-.8Zm.089,1.784v.892l-1.873-1.427v-.8Zm.178-16.769a5.916,5.916,0,0,0-.8,1.695V77.233h-.535v2.408a8.018,8.018,0,0,0-1.07-2.141v-.178l1.249-2.408,1.249,2.408v.089ZM60.438,79.73l-1.516-1.516-.357.357,2.052,2.052h0a9.891,9.891,0,0,0-2.676-1.516l-.089-.089-.535-2.141,2.052.892.178.089.089.089c.268.535.535,1.16.8,1.784m-3.39-3.568-.089-.268.714.535Zm.268,3.479h.357l1.606.714L57.762,80l-.178.535L59.1,80.8a8.955,8.955,0,0,0-2.141.357h-.178l-1.873-1.249Zm-.357,2.319.089-.089.089-.089a13.847,13.847,0,0,1,1.873-.357l-1.427.446.178.535,1.16-.357a10.254,10.254,0,0,0-2.052,1.873l-.089.089V84.1l-1.16.268Zm.535,2.23a7.431,7.431,0,0,1,1.962-1.784l-.981.981.357.357L60.081,82.5a8.545,8.545,0,0,0-1.07,2.854h0v.089l-.089.089-1.16,1.338-.268-2.408V84.19Zm2.141,1.16a5.671,5.671,0,0,1,.535-1.606l-.089,2.944-.446-1.07V85.35ZM62.757,92.4c-.089-1.427-.089-2.854-.178-4.282l.535-1.16v1.606h.535V87.045l.535,1.427.535-.178-.535-1.516,1.07,1.16.446-.357-.178-.178L65.7,85.8l.446,1.606.535-.178-.446-1.516.892,1.249.446-.268L66.5,85.171l1.427.892.268-.446-1.338-.8.446.089.178.268.357-.178.624.089.089-.535h-.178l.357-.357L67.4,82.674l1.695.981.268-.446-1.784-1.07,2.052.446.089-.535-1.695-.357,1.695-.089v-.535l-1.873.089,1.873-.624L69.536,80l-1.784.624L68.644,80h0l.714-.446L69,79.2l-.535.357-1.338-.178,1.784-.178-.089-.535-2.052.178,1.784-.8-.178-.535-1.784.8,1.516-1.338-.357-.446-1.516,1.249,1.07-1.695-.446-.268h0l-.089-.178-.535.178.089-.268h-.268l.357-.268-.357-.446-1.784,1.249,1.249-1.695-.446-.357-1.427,1.784.8-2.141-.535-.178-.624,1.784.178-1.873h-.535l-.178,2.052-.446-1.962-.535.089.446,2.052-.714-1.249.268-.446-.535-.268-.089.089h0l-.535.268.178.357-.535,1.16.446-2.052L60.17,73.4l-.446,2.052L59.546,73.4l-.535.089.178,1.873-.714-1.873-.535.178.8,2.141-1.427-1.784-.446.357,1.249,1.695-1.784-1.249-.357.446.446.357-.268.089.089.178-.446-.357-.089.268-.446.268,1.07,1.695-1.427-1.249-.357.446L56.067,78.3l-1.873-.8-.268.446,1.784.8-1.962-.268-.089.535,1.784.178-1.249.178-.535-.268-.268.446.535.357v.178H54.1l.981.624L53.3,80.087l-.178.535L55,81.247l-1.962-.089v.535l1.695.089-1.695.357.089.535,2.052-.446L53.391,83.3l.268.446,1.606-1.07L53.926,84.1l.357.357H54.1l.089.535.624-.089.357.178.178-.268.446-.089-1.338.8.268.446,1.427-.892-.981,1.427.446.268.892-1.249-.357,1.606.535.178.446-1.606.178,1.606-.178.178.446.357,1.07-1.16L58.03,88.2l.535.178.535-1.427v1.516h.535V86.866l.446.981-.089,3.568c-3.39-1.16-6.6-2.408-8.92-4.817-5.173-5.441-4.281-10.347-2.141-14.093h0l.089-.178h0l.089-.178h0l.089-.178h1.249l25.332.624h0c0,8.206-2.319,16.5-6.779,22.567a39.924,39.924,0,0,0-6.422-2.5M67.128,83.3l1.07,1.16-.535-.089ZM65.7,77.5l.268-.981.446-.178Zm-8.831,0-.714-1.16.535.178Zm-1.338,5.8-.624,1.07-.535.089ZM75.958,71.435H61.776c4.727-2.944,6.155-6.957,8.741-6.69,1.427.178,3.568.714,4.906.892h0a41.19,41.19,0,0,1,.535,5.8Zm-.892-6.6c-.714-.089-1.338-.268-2.052-.357s-1.606-.268-2.408-.357a1.52,1.52,0,0,0-.892,0c-1.427.268-2.676,1.695-3.657,2.676a22.083,22.083,0,0,1-4.638,4.014l-1.07.624-10.971-.089c1.427-3.122,5.709-8.206,7.939-7.849,1.07.178,2.587.624,3.746.892.089,1.249.268,2.587.446,3.835.089.446.089,1.338.8,1.338.8,0,.714-.892.8-1.427.357-1.427.8-2.765,1.249-4.1,2.765-1.784,2.854-7.314,8.3-7.4h.535a44.469,44.469,0,0,1,2.141,8.206ZM56.781,53.685l3.211-.624c1.873.178,4.1-1.427,5.084-1.606a.751.751,0,0,1,.624.357l-1.873.892.268.535,2.052-.981a.811.811,0,0,1,.357.714l-2.23.535.089.535,2.319-.535a.548.548,0,0,1-.089.535,26.507,26.507,0,0,1-3.479,1.16c.446,1.606,1.516,3.568,1.427,5.173v.535l-1.16-2.5-.535.268,1.606,3.211a13.039,13.039,0,0,1-.446,1.784l-1.249-4.192-.535.178,1.516,4.906a25.925,25.925,0,0,0-1.07,3.479c-.178.981,0,1.16-.178.089-.624-3.211-.624-8.92-2.141-11.061a14.511,14.511,0,0,0-2.052-.981,10.521,10.521,0,0,0-1.784-.357c-.446.089-1.16.268-1.606.357,0-.8.446-2.587,1.873-2.408m-6.065-3.3c-1.249-.357-1.249-.357.089-.357a16.945,16.945,0,0,1,6.69.981,15.809,15.809,0,0,1,2.765,1.338h-.178l-2.676.535c-2.052-1.427-4.371-1.873-6.69-2.5M83.9,105.33,71.588,93.2c9.1-15.164,6.779-39.693-6.957-50.218A24.186,24.186,0,0,0,49.377,37.9c-9.812,0-17.037,4.906-21.586,12.042l-14-13.826,3.657-4.549c21.229-3.39,42.815-3.836,63.955,0L91.568,44.23c-3.836,3.211-6.69,7.225-7.314,12.4-.714,6.244,2.052,12.488,4.371,18.107s4.638,11.328,4.638,17.483c0,5-4.281,9.544-9.366,13.112",
    transform: "translate(-0.497 -1.229)",
    fill: "#405965"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17009",
    "data-name": "Ret\\xE2ngulo 17009",
    width: 1.516,
    height: 82.597,
    transform: "translate(441.608 22.933)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2755",
    "data-name": "Caminho 2755",
    d: "M517.5,34.131l-1.338,3.657H514.2L518.749,25.3H520.8l4.549,12.488h-1.962l-1.249-3.657Zm2.23-6.69-1.7,5.084h3.479Z",
    transform: "translate(-48.962 -2.393)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2756",
    "data-name": "Caminho 2756",
    d: "M531.438,37.688,526.8,25.2h2.141l3.568,10.169L536.076,25.2h2.141l-4.638,12.488Z",
    transform: "translate(-48.829 -2.384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2757",
    "data-name": "Caminho 2757",
    d: "M543.1,34.131l-1.338,3.657H539.8L544.349,25.3H546.4l4.549,12.488h-1.962l-1.249-3.657Zm2.319-6.69-1.695,5.084H547.2Z",
    transform: "translate(-50.234 -2.393)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2758",
    "data-name": "Caminho 2758",
    d: "M554.7,25.2h1.962l6.065,9.366V25.2h1.963V37.688h-1.963l-6.155-9.277v9.277H554.7Z",
    transform: "translate(-51.843 -2.384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2759",
    "data-name": "Caminho 2759",
    d: "M579.246,36.607a6.332,6.332,0,0,1-3.925,1.338h-.267l-.089.535a1.489,1.489,0,0,1,1.338,1.606c0,1.249-.981,1.695-2.052,1.695-.267,0-.624-.089-.892-.089l.267-1.07a1.131,1.131,0,0,0,.535.089c.446,0,.892-.178.892-.624s-.446-.624-.981-.624h-.268l.178-1.516a6.249,6.249,0,0,1-5.084-6.333,6.513,6.513,0,0,1,6.333-6.511,6.776,6.776,0,0,1,3.835,1.249l-.624,1.784a4.91,4.91,0,0,0-3.122-1.07,4.378,4.378,0,0,0-4.371,4.371V31.7a4.384,4.384,0,0,0,4.1,4.638h.357a5.7,5.7,0,0,0,3.3-1.16Z",
    transform: "translate(-53.377 -2.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2760",
    "data-name": "Caminho 2760",
    d: "M585.3,34.131l-1.338,3.657H582L586.549,25.3H588.6l4.549,12.488h-1.962l-1.249-3.657Zm2.319-6.69-1.695,5.084H589.4Z",
    transform: "translate(-54.792 -2.393)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2761",
    "data-name": "Caminho 2761",
    d: "M597,25.2h1.962l6.066,9.366V25.2h1.962V37.688h-1.962l-6.155-9.277v9.277H597Z",
    transform: "translate(-56.413 -2.384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2762",
    "data-name": "Caminho 2762",
    d: "M611.9,25.2h2.943c4.192,0,6.69,2.319,6.69,6.244,0,4.014-2.5,6.244-6.69,6.244H611.9Zm3.122,10.7c2.676,0,4.371-1.516,4.371-4.46s-1.7-4.46-4.371-4.46h-1.16v9.009Z",
    transform: "translate(-58.022 -2.384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2763",
    "data-name": "Caminho 2763",
    d: "M631.222,25a6.467,6.467,0,1,1-6.422,6.511h0a6.208,6.208,0,0,1,6.065-6.422A.536.536,0,0,1,631.222,25Zm0,11.061a4.378,4.378,0,0,0,4.371-4.371v-.268a4.379,4.379,0,0,0-8.741-.535v.535a4.383,4.383,0,0,0,4.1,4.638Z",
    transform: "translate(-59.415 -2.363)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2764",
    "data-name": "Caminho 2764",
    d: "M514.678,61.815c.357.089.714.089,1.07.178.892,0,1.427-.535,1.427-1.606V51.2h2.052v9.544a2.792,2.792,0,0,1-3.122,3.033A9.829,9.829,0,0,1,514.5,63.6Z",
    transform: "translate(-49.065 -4.842)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2765",
    "data-name": "Caminho 2765",
    d: "M523.3,59.128V51.278h1.962v7.76a2.612,2.612,0,0,0,2.854,2.944c1.873,0,2.854-1.16,2.854-3.033V51.1h1.962v7.939a4.5,4.5,0,0,1-4.193,4.817h-.624A4.428,4.428,0,0,1,523.3,59.128Z",
    transform: "translate(-48.452 -4.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2766",
    "data-name": "Caminho 2766",
    d: "M537.689,51.2h1.962l6.065,9.366V51.2h1.963V63.688h-1.963l-6.155-9.277v9.277H537.6V51.2Z",
    transform: "translate(-49.996 -4.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2767",
    "data-name": "Caminho 2767",
    d: "M554.722,52.984H551.6V51.2h8.206v1.784h-3.122v10.7h-1.962Z",
    transform: "translate(-51.508 -4.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2768",
    "data-name": "Caminho 2768",
    d: "M568.722,50.9a6.467,6.467,0,1,1-6.422,6.511v-.089a6.208,6.208,0,0,1,6.065-6.422Zm0,11.15a4.6,4.6,0,1,0-4.371-4.817V57.5a4.31,4.31,0,0,0,4.1,4.549.167.167,0,0,1,.268,0Z",
    transform: "translate(-52.664 -4.812)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2769",
    "data-name": "Caminho 2769",
    d: "M580.4,60.265a2.57,2.57,0,0,0,2.408,1.784,1.752,1.752,0,0,0,1.873-1.427v-.268c0-2.676-5.62-2.052-5.62-6.065,0-1.962,1.427-3.39,3.746-3.39a3.643,3.643,0,0,1,3.657,2.587l-1.606.714a2.2,2.2,0,0,0-2.052-1.427,1.575,1.575,0,0,0-1.695,1.338v.178c0,2.5,5.62,2.052,5.62,5.976,0,2.052-1.516,3.657-4.014,3.657a4.045,4.045,0,0,1-4.014-2.765Z",
    transform: "translate(-54.436 -4.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2770",
    "data-name": "Caminho 2770",
    d: "M590.547,62.6a1.356,1.356,0,0,1,1.338,1.249v.089a4.224,4.224,0,0,1-1.695,3.389l-.8-.892a2.915,2.915,0,0,0,.981-1.338,1.281,1.281,0,0,1-1.07-1.427,1.322,1.322,0,0,1,1.249-1.07Z",
    transform: "translate(-55.579 -5.973)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2771",
    "data-name": "Caminho 2771",
    d: "M514.4,83.322a6.7,6.7,0,0,1,13.38,0,6.692,6.692,0,0,1-13.38,0Zm3.746,0a3.078,3.078,0,1,0,0-.268v.268Z",
    transform: "translate(-48.955 -7.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2772",
    "data-name": "Caminho 2772",
    d: "M538.387,80.222H535.8V77.1h8.652v3.122h-2.587v9.366H538.3V80.222Z",
    transform: "translate(-49.802 -7.293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2773",
    "data-name": "Caminho 2773",
    d: "M547.789,77.2h4.371c3.122,0,4.549,1.516,4.549,3.925a3.755,3.755,0,0,1-1.605,3.3l2.854,5.263h-3.925l-2.141-4.371h-.624v4.371H547.7Zm4.192,5.173a1.11,1.11,0,0,0,1.249-.981v-.178c0-.714-.446-1.07-1.249-1.07h-.625v2.23Z",
    transform: "translate(-51.087 -7.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2774",
    "data-name": "Caminho 2774",
    d: "M564.481,87.279l-.714,2.408H560.2L564.481,77.2h3.746l4.281,12.488h-3.568l-.714-2.408Zm1.873-6.422-1.071,3.568h2.051Z",
    transform: "translate(-52.437 -7.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2775",
    "data-name": "Caminho 2775",
    d: "M576,77.2h4.817c2.587,0,4.192,1.249,4.192,3.39a2.77,2.77,0,0,1-1.338,2.5,2.83,2.83,0,0,1,1.695,2.765c0,2.587-2.051,3.746-4.549,3.746H576Zm4.549,4.728a.82.82,0,0,0,.892-.8v-.089a.8.8,0,0,0-.714-.892h-1.16v1.784Zm.267,4.728a.99.99,0,0,0,.981-.981h0a.917.917,0,0,0-.892-.981h-1.338v1.962Z",
    transform: "translate(-54.144 -7.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2776",
    "data-name": "Caminho 2776",
    d: "M591.982,87.279l-.714,2.408H587.7L591.982,77.2h3.746l4.282,12.488h-3.568l-.714-2.408Zm1.873-6.422-1.07,3.568h2.052Z",
    transform: "translate(-55.408 -7.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2777",
    "data-name": "Caminho 2777",
    d: "M603.5,77.2h3.568v9.366h3.568v3.122H603.5Z",
    transform: "translate(-57.115 -7.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2778",
    "data-name": "Caminho 2778",
    d: "M613.689,77.2h3.568v4.638h3.925V77.2h3.568V89.688h-3.568V85.049h-4.014v4.638H613.6Z",
    transform: "translate(-58.206 -7.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2779",
    "data-name": "Caminho 2779",
    d: "M628.4,83.322a6.7,6.7,0,0,1,13.38,0,6.692,6.692,0,0,1-13.38,0Zm3.746,0a3.078,3.078,0,1,0,0-.268v.268Z",
    transform: "translate(-59.804 -7.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2780",
    "data-name": "Caminho 2780",
    d: "M515.089,103.1h3.568l4.014,7.047V103.1h3.479v12.488h-3.568l-4.1-6.957v6.957H515V103.1Z",
    transform: "translate(-47.555 -9.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2781",
    "data-name": "Caminho 2781",
    d: "M533.882,112.769l-.714,2.408H529.6l4.281-12.488h3.746l4.282,12.488h-3.568l-.714-2.408Zm.892-11.15a.473.473,0,0,0-.535.535h-2.052c0-1.695.892-2.854,2.23-2.854.981,0,1.695.535,2.23.535.357,0,.446-.178.446-.535h2.051c0,1.695-.892,2.854-2.23,2.854-.8,0-1.516-.535-2.141-.535Zm.981,4.727-1.07,3.568h2.141Z",
    transform: "translate(-49.132 -9.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2782",
    "data-name": "Caminho 2782",
    d: "M544,109.322a6.7,6.7,0,1,1,6.69,6.422C546.587,115.745,544,112.979,544,109.322Zm3.657,0a3.073,3.073,0,1,0,0-.268q0,.134,0,.268Z",
    transform: "translate(-50.687 -9.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2783",
    "data-name": "Caminho 2783",
    d: "M566.2,103.1h4.906a3.826,3.826,0,0,1,4.192,3.479v.624a4.03,4.03,0,0,1-3.657,4.192h-1.784v4.1h-3.568Zm4.282,5.352a1.106,1.106,0,0,0,1.159-1.07V107.2a1.03,1.03,0,0,0-.981-1.16h-.892v2.408Z",
    transform: "translate(-53.086 -9.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2784",
    "data-name": "Caminho 2784",
    d: "M580.481,113.179l-.713,2.408H576.2l4.281-12.488h3.746l4.282,12.488h-3.568l-.714-2.408Zm1.873-6.422-1.07,3.568h2.052Z",
    transform: "translate(-54.166 -9.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2785",
    "data-name": "Caminho 2785",
    d: "M592.089,103.1h4.371c3.122,0,4.549,1.516,4.549,3.925a3.658,3.658,0,0,1-1.605,3.3l2.854,5.263h-3.925l-2.141-4.371h-.624v4.371H592Zm4.1,5.173a1.11,1.11,0,0,0,1.249-.981v-.178c0-.714-.446-1.07-1.249-1.07h-.624v2.23Z",
    transform: "translate(-55.872 -9.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2786",
    "data-name": "Caminho 2786",
    d: "M608.682,113.179l-.714,2.408H604.4l4.281-12.488h3.746l4.281,12.488h-3.568l-.714-2.408Zm1.873-6.422-1.07,3.568h2.052Z",
    transform: "translate(-57.212 -9.752)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGovCeWhite);
export default __webpack_public_path__ + "static/media/logo-gov-ce-white.156b65e97e08fa741b4c652bbb958b12.svg";
export { ForwardRef as ReactComponent };